import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AutocompleteType } from "../../../common/types/autoComplete";
import { OrderFields } from "../orderTypes";
import { OrderFieldsProperties } from "./types";
import CommonTextField from "../../../common/components/functional/commonTextField/CommonTextField";

type Props = {
  values: OrderFields;
  handleChangeCallback: (
    name: OrderFieldsProperties,
    newValue:
      | AutocompleteType[]
      | AutocompleteType
      | Date
      | null
      | number
      | string
      | boolean,
  ) => void;
};

const AdditionalInfo = ({ values, handleChangeCallback }: Props) => {
  const { t } = useTranslation(["common", "order"]);

  const placeholder = t("common:additionalInformation");

  return (
    <>
      <Grid
        container
        item
        xs={4}
        justifyContent="flex-end"
        alignItems="center"
        sx={{ marginBottom: "20px" }}
      >
        <Typography variant="secondary">{t("common:message")}</Typography>
      </Grid>
      <Grid item xs={8}>
        <CommonTextField
          fullWidth
          size="small"
          value={values.descriptionToEezyAndCustomer}
          placeholder={placeholder}
          name="descriptionToEezyAndCustomer"
          onChange={(e) =>
            handleChangeCallback(
              e.target.name as OrderFieldsProperties,
              e.target.value,
            )
          }
          helperText={t("order:visibleToCustomerAndEezy")}
        />
      </Grid>
      <Grid
        container
        item
        xs={4}
        justifyContent="flex-end"
        alignItems="center"
        sx={{ marginBottom: "20px" }}
      >
        <Typography variant="secondary">
          {t("order:descToEezyAndCustomerAndTalent")}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <CommonTextField
          fullWidth
          size="small"
          multiline
          minRows={4}
          value={values.descriptionToEezyAndCustomerAndTalent}
          placeholder={placeholder}
          name="descriptionToEezyAndCustomerAndTalent"
          inputProps={{ maxLength: 1000 }}
          onChange={(e) =>
            handleChangeCallback(
              e.target.name as OrderFieldsProperties,
              e.target.value,
            )
          }
          helperText={t("order:descToEezyAndCustomerAndTalentHelper")}
        />
      </Grid>
    </>
  );
};

export default AdditionalInfo;
